export const RESET_STATE = 'CHAT_RESET_STATE';
export const CURRENT_ITEM = 'CHAT_CURRENT_ITEM';

export const REQUEST_LOADING = 'CHAT_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'CHAT_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'CHAT_REQUEST_FAILED';

export const CURRENT_ACTION = 'CHAT_CURRENT_ACTION';
export const RESET_ACTION = 'CHAT_RESET_ACTION';
